import {observer} from "mobx-react-lite";
import {useStores} from "../../stores";
import {Button, CircularProgress} from "@mui/material";
import {CloudDownload, Done} from "@mui/icons-material";
import React, {useEffect, useState} from "react";
import {AI_MODEL_FAKER} from "./components/demo-ai-busy/DemoAiBusy.tsx";

export const CategorizationPageHeader: React.FC = observer(() => {
    const {authStore, bagStore, categorizationReviewStore, p} = useStores();
    const approvalController = categorizationReviewStore.reviewPageController.reviewPageApprovalController;
    const pageStateController = categorizationReviewStore.reviewPageController.reviewPageStateController;
    const aiJobDelegate = categorizationReviewStore.aiJobDelegate;

    const [isFakedStartingAiRun, setIsFakedStartingAiRun] = useState(false);
    useEffect(() => {
        let intervalId: string | number | NodeJS.Timeout | undefined;
        if (isFakedStartingAiRun) {
            intervalId = setInterval(() => {
                setIsFakedStartingAiRun(false);
                categorizationReviewStore.reviewPageController.reviewPageStateController.setPage("demo-ai-run")
                AI_MODEL_FAKER.start()
                // navigate(generateHomePath(location, params, rootAppStore.app));
            }, 800);
        }
        return () => {
            clearInterval(intervalId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFakedStartingAiRun]);

    if (pageStateController.page === 'review') return <>
        {(!p.p.hideApprovalButtons && !bagStore.isSample && !categorizationReviewStore.viewOnly) &&
            <Button
                sx={{mx: 1}}
                color="primary"
                variant="outlined"
                disabled={categorizationReviewStore.reviewPageController.isLoadingData || categorizationReviewStore.viewOnly}
                onClick={() => approvalController.setSendForApprovalDialog(true)}
            >
                Send for approval
            </Button>}
        {p.p.demoFakeReinforcedCategorization &&
            <Button
                sx={{mx: 1}}
                color="primary"
                variant="outlined"
                className="btn-with-circular-progress button-spacing"
                startIcon={isFakedStartingAiRun ?
                    <CircularProgress size={14}/> : (isFakedStartingAiRun ?
                        <Done/> :
                        <CloudDownload/>)}
                disabled={isFakedStartingAiRun}
                onClick={() => {
                    setIsFakedStartingAiRun(true);
                }}
            >
                Re-Run AI
            </Button>
        }
        {p.isVertexCategorizationEnabled(authStore.isMithraStaffGroup) && <>
            <Button
                color="primary"
                variant="outlined"
                className="btn-with-circular-progress"
                style={{marginLeft: '1em'}}
                onClick={() => aiJobDelegate.openRunAiModal()}>
                Run AI
            </Button>
        </>}
    </>

    return null
})